import React from 'react';
import {array, string, object} from 'prop-types';
import {withRouteData} from 'react-static';
import Prismic from 'prismic-javascript';
import {RichText} from 'prismic-reactjs';
import linkResolver from '../utils/link-resolver';
import PrismicPreview from '../components/prismic-preview';
import Title from '../components/title/title';
import TextSection from '../components/text-section/text-section';

const TextPage = props => (
  <PrismicPreview
    publishedContent={props}
    query={{predicates: Prismic.Predicates.at('my.text_page.uid', props.uid)}}
  >
    {({body, title}) => (
      <>
        {title && <Title title={RichText.asText(title)} />}
        <div className="container">
          <div id="accordion" role="tablist">
            {body &&
              body.map((slice, index) => {
                if (slice.slice_type === 'text_section') {
                  return (
                    <TextSection
                      title={RichText.asText(slice.primary.title)}
                      text={RichText.render(slice.primary.text, linkResolver)}
                      index={index}
                    />
                  );
                }

                return null;
              })}
          </div>
        </div>
      </>
    )}
  </PrismicPreview>
);

TextPage.propTypes = {
  title: object.isRequired,
  body: array.isRequired,
  uid: string
};

TextPage.defaultProps = {
  uid: ''
};

export default withRouteData(TextPage);
